module.exports = __webpack_public_path__ + "img/fundo-login.a8600f7c.jpg";